var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDownMenuIcon = function SvgDownMenuIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "main-color-icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 9.998,
    height: 5.976
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.55 0h8.884c.413 0 .72.29.479.576-.193.23-4.1 4.817-4.433 5.208a.7.7 0 0 1-.963 0C4.272 5.502.347.897.074.564-.126.32.098 0 .55 0Z"
  })));
};
export default SvgDownMenuIcon;